import React from 'react'

import HeaderIconComponent, { Theme } from '@cinch/oxd-components/header-icon/src'
import { Brand, Menu } from '@cinch/oxd-components/icons/src'
import Modal from '@cinch/oxd-components/modal/src'
import SVG from '@cinch/oxd-components/svg/src'
import AuthButtonsContainer from '@cinch/oxd-containers/auth-buttons/src'
import SiteNavigation from '@cinch/oxd-components/navigation/src'
import BannerMobileNav from '@cinch/oxd-components/banner-mobile-nav/src'
import PartnersAuthInfo from '@cinch/oxd-containers/partners-auth-info/src'
import PartnersAuthButtonsContainer from '@cinch/oxd-containers/partners-auth-buttons/src'

import { isA2HSAvailable, triggerA2HS } from '@cinch/oxd-utils/pwa/src'

import * as styles from './mobile-navigation.module.css'
import * as navStyles from './navigation.module.css'
import * as partnersNavStyles from './partners-navigation.module.css'
import * as modalStyles from './side-menu.module.css'

const MobileNavigationComponent: React.FC<{ theme?: any; menuType?: any }> = ({
  theme = Theme.dark,
  menuType = 'main',
}) => {
  const [isOpen, setOpen] = React.useState(false)

  const mainNav = () => {
    const hasBanner = isA2HSAvailable()
    const bannerText = 'Make finding, buying and selling a car a cinch when you download the app.'
    const bannerButtonText = 'Get the app'

    return (
      <div className={styles.contents}>
        <AuthButtonsContainer />
        <SiteNavigation styles={navStyles} />
        {hasBanner && (
          <BannerMobileNav
            text={bannerText}
            buttonText={bannerButtonText}
            handleClick={triggerA2HS}
            tag={{
              event: 'Click',
              eventCategory: 'Banner',
              eventLabel: 'Feature',
              eventAction: bannerText,
            }}
          />
        )}
      </div>
    )
  }

  const partnersNav = () => (
    <div className={styles.partnersContents}>
      <div>
        <PartnersAuthInfo type={'mobile'} />
        <SiteNavigation styles={partnersNavStyles} menuType="partners" />
      </div>
      <PartnersAuthButtonsContainer />
    </div>
  )

  return (
    <div className={styles.container}>
      <HeaderIconComponent svg={Menu} onClick={() => setOpen(true)} label={'Menu'} theme={theme} />
      {isOpen && (
        <Modal
          styles={modalStyles}
          title={<SVG height="30px" width="75px" children={Brand} />}
          onClose={() => setOpen(false)}
        >
          {menuType === 'main' ? mainNav() : partnersNav()}
        </Modal>
      )}
    </div>
  )
}

export default MobileNavigationComponent
